import React, {useEffect, useState} from "react";
import "./chatbotHome.css";
import ChatbotInput from "./components/chatbotInput/chatbotInput";
import {TitlePage} from "../../shared";
import ChatbotUserMsg from "./components/chatbotUserMsg/chatbotUserMsg";
import ChatbotResponseMsg from "./components/chatbotResponseMsg/chatbotResponseMsg";
import {isMobileDevice, uuidBase64Url} from "../../../utils/utils";
import {useChatStore} from "../store/chatbotStore";
import ChatbotTitle from "./components/chatbotTitle/chatbotTitle";
import ChatbotNoRights from "./components/chatbotNoRights/chatbotNoRights";
import {Helmet} from "react-helmet";
import icon from "../../../images/pageIcon.png";
import ChatbotSidebar from "../chatbotSidebar/chatbotSidebar";
import {ChatbotApi} from "../../../apis/chatbot/towersChatbotApi";

const ChatbotHome = ({includeSidebar}) => {
    const [messages, setMessages] = useState([]);
    const [thinking, setThinking] = useState(false);
    const [generating, setGenerating] = useState(false);
    const [touched, setTouched] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const useOwnSidebar = includeSidebar || isMobileDevice();

    const {
        currentConversation,
        setCurrentConversation,
        addConversation,
        hasPermission,
    } = useChatStore();

    useEffect(() => {
        setIsSidebarOpen(false);
        if (!currentConversation) {
            clearConversation();
            return;
        }
        ChatbotApi.getConversationChatbot(currentConversation).then((data) => {
            console.log("Fetched conversation messages:", data);
            const messages = data.conversation?.messages || [];
            if (messages.length > 0) setTouched(true);
            setMessages(messages.filter(x => x.role !== "tool" && x.content).map(x => ({
                ...x,
                text: x.content,
                sender: x.role
            })));
        }).catch((err) => {
            console.error("Error fetching conversation messages:", err);
        });
    }, [currentConversation]);

    useEffect(() => {
        return () => {
            clearConversation();
        }
    }, []);

    const sendMessage = (input) => {
        if (!input.trim()) return;

        let usingChatId = currentConversation;

        if (!usingChatId) {
            const newChatId = uuidBase64Url();
            setCurrentConversation(newChatId);
            usingChatId = newChatId;
            console.log("New chatId:", newChatId);
            addConversation({id: newChatId, title: input, lastMessageAt: new Date().toISOString()});
        }

        setMessages((prev) => [...prev, {sender: "user", text: input}]);
        setThinking(true);
        setGenerating(false);
        setTouched(true);
        ChatbotApi.chat(
            {input, chatId: usingChatId},
            (evt) => {
                if (evt.type === "chunk") {
                    setGenerating(true);
                    setMessages((prev) => {
                        const last = prev[prev.length - 1];
                        if (last?.sender === "assistant") {
                            return [...prev.slice(0, -1), {sender: "assistant", text: last.text + evt.data}];
                        } else {
                            return [...prev, {sender: "assistant", text: evt.data}];
                        }
                    });
                } else if (evt.type === "done" || evt.type === "finish") {
                    setThinking(false);
                    setGenerating(false);
                }
            },
            (err) => {
                setMessages((prev) => [...prev, {
                    sender: "assistant",
                    error: true,
                    text: `Lo siento, ha ocurrido un error. Por favor, inténtalo de nuevo. Detalles: ${err.message}`,
                    errorDetails: err
                }]);
                setThinking(false);
            }
        );
    };

    const clearConversation = () => {
        setMessages([]);
        setCurrentConversation(null);
        setTouched(false);
    }

    const openSidebar = (e) => {
        setIsSidebarOpen(!isSidebarOpen);
    }

    if (!hasPermission("viewTobiAI")) {
        return (

            <>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>SquadDisk | Firulais</title>
                    <link rel="icon" href={icon}/>
                </Helmet>
                <div onClick={clearConversation} className="chatbot-header">
                    <TitlePage title="Firulais AI" icon="fa-solid fa-dog"/>
                </div>
                <div className="chat-container">
                    <ChatbotNoRights/>
                </div>
            </>
        );
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>SquadDisk | Firulais</title>
                <link rel="icon" href={icon}/>
            </Helmet>
            <TitlePage title={
                <>
                    <span className="chatbot-header__title-text">Firulais AI</span>
                    <small className="text-muted">&nbsp;beta</small>
                </>
            } icon="fa-solid fa-dog"
                       rightClass="gap-3"
                       rightOptions={
                           <>
                               <div onClick={clearConversation} className="chatbot-header__sidebar-btn">
                                   <i className="fa-solid fa-pen-to-square fa-lg"></i>
                               </div>
                               {useOwnSidebar &&
                                   <div className="chatbot-header__sidebar-btn" onClick={openSidebar}>
                                       <i className="fa-solid fa-bars fa-lg"></i>
                                   </div>
                               }
                           </>
                       }/>
            <div className="chat-container">
                <div className="chat-container__chat">
                    <div className="chat-container__chat-window">
                        {messages.map((msg, i) => {
                                if (msg.sender === "user") {
                                    return <ChatbotUserMsg key={i} msg={msg} isFirst={i === 0}
                                                           isLast={i === messages.length - (thinking ? 1 : 2)}/>
                                }

                                return <ChatbotResponseMsg key={i} msg={msg} isLast={i === messages.length - 1}
                                                           isGenerating={generating}/>;
                            }
                        )}
                        {thinking && !generating &&
                            <ChatbotResponseMsg msg={undefined} isThinking={true} isLast={true}/>}
                    </div>
                </div>
                {!touched && <ChatbotTitle/>}
                <ChatbotInput sendMessage={sendMessage} isLoading={thinking} touched={touched}/>
            </div>
            <div className="chatbot-home__legal-warning">
                <div>
                    Respuestas generadas por IA. Puede contener errores.
                </div>
                <div>
                    gpt-5-nano-2025-08-07
                </div>
            </div>
            {useOwnSidebar &&
                <>
                    <div className={`chatbot-home__sidebar-overlay ${isSidebarOpen ? 'open' : ''}`}
                         onClick={openSidebar}>
                    </div>
                    <div className={`chatbot-home__sidebar ${isSidebarOpen ? 'open' : ''}`}>
                        <TitlePage title="" icon="fa-solid fa-dog"
                                   rightClass="gap-3"
                                   rightOptions={
                                       <>
                                           <div onClick={openSidebar} className="chatbot-header__sidebar-btn">
                                               <i className="fa-solid fa-times fa-lg"></i>
                                           </div>
                                       </>
                                   }/>
                        <ChatbotSidebar/>
                    </div>
                </>
            }
        </>
    );
};

export default ChatbotHome;
